<template>
  <b-modal
    id="add-year-modal"
    ref="addAcYearModal"
    title="เพิ่มปีการศึกษาใหม่"
    ok-title="บันทึกข้อมูล"
    cancel-title="ยกเลิก"
    :ok-disabled="this.$v.form.$anyError"
    @ok="submit"
    @close="cancel"
  >
    <b-form-group label-cols="4" label-cols-lg="3" label="ปีการศึกษา">
      <b-form-input v-model="$v.form.year.$model" :state="$v.form.year.$dirty ? !$v.form.year.$error : null" placeholder="ตัวเลขสี่หลักเท่านั้น เช่น 2561" />
    </b-form-group>
    <b-form-group label-cols="4" label-cols-lg="3" label="ช่วงเวลา">
      <v-date-picker
        v-model="$v.form.period.$model"
        :columns="2"
        :popover="{ placement: 'bottom', visibility: 'click' }"
        color="orange"
        locale="th"
        mode="range"
      >
        <input
          slot-scope="{ inputProps, inputEvents }"
          type="text"
          class="form-control form-control-sm"
          :class="{ 'is-invalid': $v.form.period.$dirty ? $v.form.period.$error : false, 'is-valid': !$v.form.period.$error && $v.form.period.$model }"
          v-bind="inputProps"
          v-on="inputEvents"
        >
      </v-date-picker>
    </b-form-group>
  </b-modal>
</template>
<script>
import gql from 'graphql-tag'
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        year: '',
        period: ''
      }
    }
  },
  methods: {
    cancel () {
      this.form = { year: '', period: '' }
    },
    async submit (event) {
      event.preventDefault()

      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }

      await this.$apollo.mutate({
        mutation: gql`mutation ($input: AcYearCreateInput!) { acYearCreate(input: $input) { id } }`,
        variables: {
          input: {
            year: this.form.year,
            startAt: this.form.period.start,
            endAt: this.form.period.end
          }
        }
      }).then(async () => {
        this.$bvToast.toast('เพิ่มปีการศึกษาสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })

        this.$nextTick(() => { this.$refs.addAcYearModal.hide() })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })

      this.$emit('finish')
    }
  },
  validations: {
    form: {
      year: { required, numeric, minLength: minLength(4), maxLength: maxLength(4) },
      period: { required }
    }
  }
}
</script>
